module.exports = __webpack_public_path__ + "static/fp-course-bg-87db88b6c25cd7f779791d04f42ff1ea.jpg";